"use client";
import React from "react";

export default function ExploreSkeleton() {
  return (
    <section className="py-5 bg-light">
      <div className="container">

        {/* ===== Heading ===== */}
        <div className="text-center mb-4">
          <div className="explore-skeleton explore-skel-title mx-auto mb-2"></div>
          <div className="explore-skeleton explore-skel-line mx-auto mb-3"></div>
          <div className="explore-skeleton explore-skel-subtitle mx-auto mb-3"></div>

          {/* Search */}
          <div className="explore-skeleton explore-skel-search mx-auto"></div>
        </div>

        {/* ================= DESKTOP ================= */}
        <div className="d-none d-lg-flex gap-4">

          {/* LEFT LIST */}
          <div className="flex-grow-1">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="d-flex gap-3 mb-4 p-3 bg-white rounded shadow-sm"
              >
                <div className="explore-skeleton explore-skel-thumb"></div>

                <div className="flex-grow-1">
                  <div className="explore-skeleton explore-skel-text mb-2"></div>
                  <div className="explore-skeleton explore-skel-small mb-2"></div>
                  <div className="explore-skeleton explore-skel-small mb-3"></div>

                  <div className="d-flex gap-2">
                    <div className="explore-skeleton explore-skel-btn-sm"></div>
                    <div className="explore-skeleton explore-skel-price"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT PREVIEW */}
          <div style={{ width: "50%" }}>
            <div className="bg-white p-3 rounded shadow-sm h-100">

              <div className="explore-skeleton explore-skel-main-img mb-3"></div>

              <div className="explore-skeleton explore-skel-text mb-2"></div>
              <div className="explore-skeleton explore-skel-small mb-2"></div>
              <div className="explore-skeleton explore-skel-small mb-3"></div>

              {/* Amenities */}
              <div className="d-flex flex-wrap gap-2 mb-3">
                {[...Array(8)].map((_, i) => (
                  <div key={i} className="explore-skeleton explore-skel-pill"></div>
                ))}
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-between">
                <div className="explore-skeleton explore-skel-btn"></div>
                <div className="explore-skeleton explore-skel-btn"></div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= MOBILE ================= */}
        <div className="d-block d-lg-none">
          <div className="row g-3">
            {[...Array(2)].map((_, i) => (
              <div className="col-6" key={i}>
                <div className="bg-white rounded shadow-sm p-2">

                  <div className="explore-skeleton explore-skel-card-img mb-2"></div>

                  <div className="explore-skeleton explore-skel-text mb-1"></div>
                  <div className="explore-skeleton explore-skel-small mb-2"></div>

                  <div className="explore-skeleton explore-skel-price"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}